import { useContext, useState } from "react";
import {List,ListItemButton,ListItemText} from "@mui/material";
import "../modal/modal.css";
import { callPostApi } from "../../function/ApiCallFunction";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../context/DataContext";

export default function SellerStoreListInfo({ dataArr, onClose }) 
{
    const [activeStoreId, setActiveStoreId] = useState(dataArr?.store_id || "");
    const [loading, setLoading] = useState(false);

    const {setLoginData } = useContext(DataContext);

    const navigate = useNavigate();

    const storeListArr   = Array.isArray(dataArr.store_list) ? dataArr.store_list: [];

    const refreshPage = async (store_id) => 
    {
        if (loading) return;
        try 
        { 
            setLoading(true);
            setActiveStoreId(store_id); // highlight immediately

            const payload = { mod: "STORE_DETAIL", data_arr: { store_id, }};
            const apiResult = await callPostApi("store-login", payload);

            if (apiResult.status === "200" && apiResult.data) 
            { 
                setLoginData(prev => 
                {
                    const updated = {...prev, store_info: apiResult.data.store_info };
                    sessionStorage.clear();
                    sessionStorage.setItem('loginData', JSON.stringify(updated));
                    return updated;
                });

                onClose?.(); // close modal after success

                navigate("/home", { replace: true });
            }
        } 
        catch (error) { console.error("Store switch failed:", error); } 
        finally { setLoading(false); }
    };

    // ✅ Conditional rendering without skipping hooks
    if (!dataArr) return null;
          
    return (
        <div className="modal-overlay">
            <div className="modal-container" style={{ maxWidth: "40%" }}>

              <div className="headerStyles"><h6>Store List</h6><span className="closeButtonStyles" onClick={onClose} > X </span></div>

                {/* CONTENT */}
                <div className="modal-content">
                    <div className="row">
                      <List>
                          {storeListArr.map(store => {
                              const isSelected = store.store_id === activeStoreId;

                              return (
                                  <ListItemButton key={store.store_id} selected={isSelected} onClick={() => refreshPage(store.store_id)}
                                        sx={{ borderRadius: 1, mb: 0.5, backgroundColor: isSelected ? "#5bc760" : "inherit" }} >
                                      <ListItemText primary={store.store_name} primaryTypographyProps={{ fontWeight: isSelected ? "600" : "400" }} />
                                  </ListItemButton>
                              );

                          })}
                      </List>
                    </div>
                </div>

                <div  className="modal-actions" style={{ justifyContent: "flex-end" }} >
                    <button onClick={onClose} className="btn-group btn-confirm m-1" > Close </button>
                </div>

            </div>
        </div>
    );
}
